import PagesService from "../../services/pages.service";

const state = {

    projectPages : [],
    pageResources: [],

};

const mutations = {

    set_project_pages(state, payload) {
        state.projectPages = payload;
    },
    set_page_resources(state, payload) {
        state.pageResources = payload;
    },
    set_none() {
    }
};

const actions = {

    async getProjectPages({commit}, payload) {
        const pages = await PagesService.getPagesByProject(payload);
        commit("set_project_pages", pages);
        return pages;
    },
    async getPageResources({commit}, payload) {
        const resources = await PagesService.getResourcesByPageService(payload);
        commit("set_page_resources", resources);
        return resources;
    },
    async addPage({commit}, payload) {
        const addpage = await PagesService.addPageService(payload);
        commit("set_none");
        return addpage;
    },
    async deletePage({commit}, payload) {
        const deletepage = await PagesService.deletePageService(payload);
        commit("set_none");
        return deletepage;
    },
    /*
    async addResource({commit}, {resourceId, pageId}) {
       // const addreso = await RolesService.addUserRoleService(resourceId, pageId)
        commit("set_none", addreso);
        return addreso;
    },*/

    async addResource({commit}, payload) {
        const addres = await PagesService.addResourceService(payload);
        commit("set_none");
        return addres;
    },
    async deleteResource({commit}, payload) {
        const deleteres = await PagesService.deleteResourceService(payload);
        commit("set_none");
        return deleteres;
    },




    }
;


export default {
    namespaced: true,
    state,
    mutations,
    actions
}
